/* eslint-disable camelcase */
import * as pc from 'playcanvas';
import gsap from 'gsap';
import {UI} from './UI';
import {Component_BlendShape} from './components/Component_BlendShape';
import {IRWNCamera} from './IRWNCamera';
import {PlantScene} from './PlantScene';

const BreathSystem = {
  Params: {
    clock: 0,
    durationIn: 5,
    durationOut: 5,
    easeIn: 'sine.inOut',
    easeOut: 'sine.inOut',
    startDelay: 0.5,
    repeatDelay: 0.5,
  },
  playcanvasApp: undefined,
  root: undefined,

  // entities
  e_container: undefined,
  txt_breath: undefined,
  txt_in: undefined,
  txt_out: undefined,
  active: false,

  init: function(playcanvasApp) {
    this.playcanvasApp = playcanvasApp;
    this.root = playcanvasApp.root;
    this.setupUI();
  },
  setupUI: function() {
    // master container
    this.e_container = UI.addGroupElement('container', UI.e_screen);
  },
  start: function() {
    this.active = true;
    this.intro();
    BreathSystem.textDisplayCount = 3;
  },
  intro: function() {
    document.getElementById('breathe_in').style.letterSpacing = 0 + 'em';
    document.getElementById('breathe_out').style.letterSpacing = 0 + 'em';

    gsap.to(Component_BlendShape.MasterSettings, {offsetScale: 0, duration: 3});
    gsap.to(Component_BlendShape.MasterSettings, {clock: 0, duration: 3, callbackScope: this, onComplete: this.onIntroComplete});
    const camConfig = BreathSystem.CameraConfigs[PlantScene.plantID];
    IRWNCamera.goto(camConfig.lookX, camConfig.lookY, 0, 7, camConfig.fov, 4, 'strong.inOut');
  },
  onIntroComplete: function() {
    const m = Component_BlendShape.MasterSettings;
    m.overrideActive = true;
    const params = BreathSystem.Params;
    if (BreathSystem.timeline != null) {
      BreathSystem.timeline.pause();
      BreathSystem.timeline.clear();
    }
    BreathSystem.timeline = gsap.timeline({repeat: -1, repeatDelay: params.repeatDelay, callbackScope: BreathSystem, onUpdate: BreathSystem.breatheTweenUpdate});
    // in
    BreathSystem.timeline.to(m, {clock: 1, duration: params.durationIn, ease: params.easeIn, onStart: BreathSystem.onBreathInStart}, 0);
    // out
    BreathSystem.timeline.to(m, {clock: 0, duration: params.durationOut, ease: params.easeOut, onStart: BreathSystem.onBreathOutStart}, params.durationIn);
  },
  breatheTweenUpdate: function() {
  },
  outro: function() {
    gsap.to(IRWNCamera.Params, {fov: 35, duration: 4, ease: 'strong.inOut', callbackScope: this, onUpdate: this.onCamTweenUpdate});
    gsap.killTweensOf('.breathe_in');
    gsap.killTweensOf('.breathe_out');
    gsap.to('.breathe_in', {opacity: 0, duration: 3});
    gsap.to('.breathe_out', {opacity: 0, duration: 3});
    IRWNCamera.goto(0, 0, 0, 7, 35);
  },
  onBreathInStart: function() {
    BreathSystem.textDisplayCount--;
    if (BreathSystem.textDisplayCount>=0) {
      const params = BreathSystem.Params;
      gsap.fromTo('.breathe_in', {scale: 1}, {scale: '1.5', ease: 'none', duration: params.durationIn});
      gsap.fromTo('.breathe_in', {letterSpacing: '0em'}, {letterSpacing: '0.1em', ease: 'none', duration: params.durationIn});
      gsap.fromTo('.breathe_in', {opacity: 0}, {opacity: 1, duration: params.durationIn * 0.5});
      gsap.to('.breathe_in', {opacity: 0, duration: params.durationIn * 0.5, delay: params.durationIn * 0.5});
    }
  },
  onBreathOutStart: function() {
    if (BreathSystem.textDisplayCount>=0) {
      const params = BreathSystem.Params;
      gsap.fromTo('.breathe_out', {scale: 1}, {scale: '1.5', ease: 'none', duration: params.durationIn});
      gsap.fromTo('.breathe_out', {letterSpacing: '0em'}, {letterSpacing: '0.1em', ease: 'none', duration: params.durationIn});
      gsap.fromTo('.breathe_out', {opacity: 0}, {opacity: 1, duration: params.durationIn * 0.5});
      gsap.to('.breathe_out', {opacity: 0, duration: params.durationIn * 0.5, delay: params.durationIn * 0.5});
    }
  },
  css_setOpacity: function(id, value) {
    document.getElementById(id).style.opacity = value;
  },
  css_setSpacing: function(id, value) {
    document.getElementById(id).style.letterSpacing = value + 'em';
  },
  stop: function() {
    //TODO Kill message timers when exiting BREATHE mode
    this.active = false;
    if (this.timeline != null) {
      this.timeline.pause();
      this.timeline.clear();
      // delete this.timeline;
    }
    this.outro();
    Component_BlendShape.MasterSettings.overrideActive = false;
  },
};


BreathSystem.CameraConfigs = {
  _1_ANTHER: {
    lookX: 0.16,
    lookY: 1.02,
    fov: 15.63,
  },
  _2_CONVO: {
    lookX: 0.16,
    lookY: 1.42,
    fov: 15.63,
  },
  _3_TRICHO: {
    lookX: -0.48,
    lookY: 1.16,
    fov: 15.63,
  },
  _4_ANA: {
    lookX: 0,
    lookY: 1.16,
    fov: 16.71,
  },
  _5_PETROR: {
    lookX: 0,
    lookY: 1.62,
    fov: 10,
  },
  _6_HYPO: {
    lookX: 0.06,
    lookY: 0.86,
    fov: 19.93,
  },
  _7_MALVA: {
    lookX: -0.04,
    lookY: 1.22,
    fov: 20,
  },
  _8_NYMPH: {
    lookX: 0,
    lookY: 0.82,
    fov: 18.86,
  },
  _9_MESEM: {
    lookX: 0.26,
    lookY: 0.96,
    fov: 18.86,
  },
  _10_CALEN: {
    lookX: -0.24,
    lookY: 1.16,
    fov: 17.78,
  },
  _11_HIERA: {
    lookX: 0,
    lookY: 0.96,
    fov: 19.93,
  },
  _12_HEMERO: {
    lookX: 0,
    lookY: 1.12,
    fov: 16.71,
  },
  _13_PAPA: {
    lookX: 0,
    lookY: 1.06,
    fov: 19.93,
  },
};

export {BreathSystem};
